var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJs1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    rx: 10,
    fill: "#FF4D61"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 37,
    width: 63,
    height: 47,
    fill: "#111827"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 5.875C9.00901 5.875 5.875 9.00901 5.875 12.875V81.125C5.875 84.991 9.00901 88.125 12.875 88.125H81.125C84.991 88.125 88.125 84.991 88.125 81.125V12.875C88.125 9.00901 84.991 5.875 81.125 5.875H12.875ZM49.9375 69.7656C49.9375 77.7721 45.2081 81.6754 38.3619 81.6754C32.1785 81.6754 28.5892 78.4735 26.768 74.6088L33.0616 70.7993C34.2751 72.9528 35.1968 74.7741 37.846 74.7741C40.0491 74.7741 41.8594 73.7808 41.8594 69.9162V44.0625H49.9375V69.7656ZM68.1775 81.4918C61.0009 81.4918 56.3633 78.2532 54.0996 73.7808L60.4023 70.1328C62.0547 72.839 64.2119 74.6419 68.0215 74.6419C71.2234 74.6419 73.0832 73.2245 73.0832 71.0159C73.0832 68.3666 71.1683 67.4285 67.6341 65.8753L65.7027 65.0454C60.1251 62.6734 56.4275 59.6918 56.4275 53.3964C56.4275 47.6003 60.843 43.3667 67.7443 43.3667C72.6591 43.3667 76.1896 44.8942 78.7323 49.3665L72.7031 53.2422C71.3776 50.8683 69.9492 49.9375 67.7351 49.9375C65.4714 49.9375 64.0357 51.3732 64.0357 53.2422C64.0357 55.561 65.4714 56.4991 68.7834 57.9348L70.7148 58.7629C77.2856 61.5792 80.985 64.4543 80.985 70.9094C80.9869 77.8676 75.5213 81.4918 68.1775 81.4918Z",
    fill: "#FF4D61"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs1);
export default __webpack_public_path__ + "static/media/js1.21c5f4c865e9b57781212c699084a75b.svg";
export { ForwardRef as ReactComponent };